import { render, staticRenderFns } from "./GeneralGiftsIndex.vue?vue&type=template&id=7d642eb6"
import script from "./GeneralGiftsIndex.vue?vue&type=script&lang=js"
export * from "./GeneralGiftsIndex.vue?vue&type=script&lang=js"
import style0 from "./GeneralGiftsIndex.vue?vue&type=style&index=0&id=7d642eb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports